import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { getIsMobileWidth } from '@elem/utils/devices';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const asset = '/media/community/pc/';
const { EFPic } = createEFPic(asset);

export default function JoinUsNow() {
    const { Link } = useGlobal();
    const { t } = useLang('communitylang');
    const [activeTab, setActiveTab] = useState(0);
    const [winW, setWinW] = useState(390);
    const tabs = [t('joinUsNow.tab_1'), t('joinUsNow.tab_2'), t('joinUsNow.tab_3')];
    const isMobile = getIsMobileWidth(); //是否是移动端

    const clickTab = (key: number) => {
        scrollBar(key);
        if (key !== activeTab) {
            setActiveTab(key);
        }
    };

    const cardsData = [
        {
            key: 1,
            title: t('joinUsNow.card_1_title'),
            desc: t('joinUsNow.card_1_desc'),
            img: ['area_1.png', 'area_1.png'],
            url: 'https://bit.ly/3Mxta6S',
        },
        {
            key: 2,
            title: t('joinUsNow.card_2_title'),
            desc: t('joinUsNow.card_2_desc'),
            img: ['area_2.png', 'area_2.png'],
            url: 'https://bit.ly/3IAwHAp',
        },
        {
            key: 3,
            title: t('joinUsNow.card_3_title'),
            desc: t('joinUsNow.card_3_desc'),
            img: ['area_3.png', 'area_3.png'],
            url: 'https://bit.ly/3Wr4G3M',
        },
        {
            key: 4,
            title: t('joinUsNow.card_4_title'),
            desc: t('joinUsNow.card_4_desc'),
            img: ['area_4.png', 'area_4.png'],
            url: 'https://bit.ly/3WAr7DJ',
        },
        {
            key: 5,
            title: t('joinUsNow.card_5_title'),
            desc: t('joinUsNow.card_5_desc'),
            img: ['area_5.png', 'area_5.png'],
            url: 'https://bit.ly/421ttMX',
        },
        {
            key: 6,
            title: t('joinUsNow.card_6_title'),
            desc: t('joinUsNow.card_6_desc'),
            img: ['area_6.png', 'area_6.png'],
            url: 'https://bit.ly/3IvGjMr',
        },
    ];

    const productsData = [
        {
            key: 1,
            name: t('products.tab_1.name_1'),
            img: ['product_1.jpg', 'product_1.jpg'],
            url: 'https://bit.ly/430SN7e',
        },
        {
            key: 2,
            name: t('products.tab_1.name_2'),
            img: ['product_2.jpg', 'product_2.jpg'],
            url: 'https://bit.ly/3IzFhPJ',
        },
        {
            key: 4,
            name: t('products.tab_1.name_4'),
            img: ['product_4.jpg', 'product_4.jpg'],
            url: 'https://bit.ly/3MpyEAJ',
        },
        {
            key: 3,
            name: t('products.tab_1.name_3'),
            img: ['product_3.jpg', 'product_3.jpg'],
            url: 'https://bit.ly/42068eG',
        },
        {
            key: 5,
            name: t('products.tab_1.name_5'),
            img: ['product_5.jpg', 'product_5.jpg'],
            url: 'https://bit.ly/3BN8wL4',
        },
    ];
    const OFFSET_MAP: any = {
        0: 0,
        1: (540 - winW) / 2,
        2: 540 - winW,
    };
    const scrollBar = (key: number) => {
        const wrapper = document.querySelector<HTMLDivElement>('#community-page-D .scroll');
        if (!wrapper || !isMobile) return;
        wrapper.scrollTo({
            left: OFFSET_MAP[key],
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        setWinW(window.innerWidth);
    }, []);

    return (
        <div id="community-page-D" className={`joinUsNow ${css.joinUsNow}`}>
            <p className="title">{t('joinUsNow.gap_title')}</p>
            <div className="scroll hidden-scrollbar">
                <div className="tab-btns">
                    {tabs.map((item, index) => (
                        <p key={index} className={`tab-item ${index === activeTab ? 'active-tab' : ''}`} onClick={() => clickTab(index)}>
                            {item}
                        </p>
                    ))}
                </div>
            </div>
            <div className="tab-content">
                <div className={`tab ${activeTab == 0 ? 'show' : ''}`}>
                    <div className="regional-cards">
                        {!isMobile &&
                            cardsData.map((card) => (
                                <Link
                                    key={card.key}
                                    href={card.url}
                                    ariaLabel={t('joinUsNow.join')}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'community_button',
                                        list_name: t('joinUsNow.gap_title'),
                                        button_name: t('joinUsNow.join'),
                                    }}
                                >
                                    <div className="card-item">
                                        <EFPic className="area-img" name={card.img} />
                                        <p className="item-title">{card?.title}</p>
                                        <p className="btn-text">{t('joinUsNow.join')}</p>
                                    </div>
                                </Link>
                            ))}
                        {isMobile && (
                            <Swiper
                                modules={[Pagination]}
                                pagination={{
                                    clickable: true,
                                }}
                                navigation={false}
                                className="card-swiper"
                                slidesPerView="auto"
                                spaceBetween={(winW / 375) * 12}
                            >
                                {cardsData.map((card) => (
                                    <SwiperSlide className="swiper-item" key={card.key}>
                                        <Link
                                            href={card.url}
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'community_button',
                                                list_name: t('joinUsNow.gap_title'),
                                                button_name: t('joinUsNow.join'),
                                            }}
                                        >
                                            <div className="card-item">
                                                <EFPic className="area-img" name={card.img} />
                                                <p className="item-title">{card?.title}</p>
                                                <p className="btn-text">{t('joinUsNow.join')}</p>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}
                    </div>
                    <p className="bottom-tip">{t('joinUsNow.bottom_tip')}</p>
                </div>
                <div className={`tab ${activeTab == 1 ? 'show' : ''}`}>
                    <div className="products-box">
                        <div className="flex-box">
                            {productsData.map((product) => (
                                <div key={product.key} className={`product-item ${product.key == 1 ? 'big' : ''}`}>
                                    <div className="img-box">
                                        <EFPic className="product-img" name={product.img} />
                                    </div>
                                    <p className="item-name">{product?.name}</p>
                                    <Link
                                        className="join-btn"
                                        href={product.url}
                                        ariaLabel={t('products.join')}
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'community_button',
                                            list_name: t('products.title'),
                                            button_name: t('products.join'),
                                        }}
                                    >
                                        {t('products.join')}
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={`tab ${activeTab == 2 ? 'show' : ''}`}>
                    <div className="reddit-img-box">
                        <Link
                            href="https://bit.ly/430SN7e"
                            ariaLabel={t('redditSection.join')}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'community_button',
                                list_name: t('redditSection.title'),
                                button_name: t('redditSection.join'),
                            }}
                        >
                            <div className="reddit-img">
                                <NextImage src={require('@publicLocal/community/pc/reddit_img.jpg')} />
                            </div>
                        </Link>
                        <div className="reddit-tips">
                            <p className="reddit-desc">{t('redditSection.desc')}</p>
                            <Link
                                className="join-btn"
                                href="https://bit.ly/3Cu520j"
                                ariaLabel={t('redditSection.join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('redditSection.title'),
                                    button_name: t('redditSection.join'),
                                }}
                            >
                                {t('redditSection.join')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
